<template>
  <div class="kpi-card">
    <span class="kpi-label">{{ label }}</span>
    <span class="kpi-value">{{ formattedValue }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  label: string
  value: number
}>()

const formattedValue = computed(() => props.value.toLocaleString())
</script>

<style scoped>
.kpi-card {
  height: 100%;
  background: var(--p-content-background);
  border: 1px solid var(--p-content-border-color);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.kpi-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--p-text-muted-color);
}

.kpi-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--p-text-color);
  line-height: 1.2;
}
</style>
